import React from 'react';

import Layout from '../components/Layout';

class CredentialTypes extends React.Component {

    render(){
        return(
            <Layout>
                <h1>Credential Types</h1>
            </Layout>
        );
    }
}

export default CredentialTypes;